export * from './title-case.pipe';
export * from './pipes.module';
